module.exports = __webpack_public_path__ + "static/media/U1-T2-1-1e.59d35fbc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/U1-T2-1-1e.mp3
// module id = 505
// module chunks = 0